import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input, SchoolSelect } from './Components'
import chika from '../../assets/images/auth/chika.png'
import kiosk from '../../assets/images/auth/kiosk.png'
import svg from '../../assets/images/auth/Vector108.svg'
import svg2 from '../../assets/images/auth/Vector109.svg'
import { useDispatch, useSelector } from 'react-redux'
import { auth } from '../../actions/auth'
import { Navigate, useLocation } from 'react-router-dom'
import { AUTH_ERROR, SET_AUTH_BASE } from '../../actions/types'
import { version, DNEVNIK2_URL, IS_JOURNAL_MODE } from '../../assets/const'


export default function Auth() {

  const dispatch = useDispatch()
  const { token, authError, base } = useSelector(state => state.auth)
  const location = useLocation()

  const [schools, setSchools] = useState([])
  const [schoolsLoading, setSchoolsLoading] = useState(false)
  const [schoolError, setSchoolError] = useState('')

  useEffect(() => {
    dispatch({ type: AUTH_ERROR, payload: null })
  }, [])

  useEffect(() => {
    if (!IS_JOURNAL_MODE) return
    setSchoolsLoading(true)
    fetch(`${DNEVNIK2_URL}/api/schools`)
      .then(r => r.json())
      .then(data => setSchools(data))
      .catch(() => setSchools([]))
      .finally(() => setSchoolsLoading(false))
  }, [])

  const {
    values,
    handleChange,
    handleSubmit,
    handleBlur
  } = useFormik({
    initialValues: { username: '', password: '' },
    onSubmit: values => {
      if (IS_JOURNAL_MODE && !base) {
        setSchoolError('Выберите школу')
        return
      }
      dispatch(auth(values))
    },
    // validationSchema: validationSchema
  })


  if (token) return <Navigate to={location.state?.from || '/'} />


  const error = () => {
    if (authError) return ' '
    // if (values[fieldName].length > 120) return '120'
  }



  return (
    <div className={styles.wrapper}>

      <header className={styles.header}>
        <br />
        <img src='/images/LMSLogo.png' alt='o_O' />
        <h1>Система управления обучением</h1>
      </header>
      <main>
        <form onSubmit={handleSubmit} className={styles.form}>
          <h1>Авторизация</h1>
          {IS_JOURNAL_MODE && (
            <SchoolSelect
              value={base || ''}
              onChange={e => {
                dispatch({ type: SET_AUTH_BASE, payload: e.target.value })
                setSchoolError('')
              }}
              schools={schools}
              loading={schoolsLoading}
              error={schoolError}
            />
          )}
          <Input
            name='username'
            value={values.username}
            placeholder='E-mail, логин, номер телефона'
            onChange={handleChange}
            onBlur={handleBlur}
            error={authError !== 'password' && authError}
          />
          <Input
            name='password'
            type='password'
            value={values.password}
            placeholder='Пароль'
            onChange={handleChange}
            onBlur={handleBlur}
            error={authError === 'password' && authError}
          />
          <button type='submit'>Вход</button>
        </form>

      </main>

      <img src={chika} className={styles.chikaImg} alt='o_O' />
      <img src={kiosk} className={styles.kioskImg} alt='o_O' />

      <footer className={styles.footer}>
        <div>
          <img src={svg} alt='o_O' />
          <span>www.nintegra.ru</span>
        </div>
        <div>
          <img src={svg2} alt='o_O' />
          <span>+7(495)780-76-71</span>
        </div>
        <div className={styles.version}>Версия {version}</div>
      </footer>
    </div>
  )
}
